// Types
import { NewFeatureCarouselModalType } from 'Dashboard/components/NewFeatureCarouselModal/NewFeatureCarouselModal.types';

// Constants
import Colors from 'Wpds/colors/ColorConstants';
import { Illustrations } from 'Wpds/components/illustration';

export const getQsgCompletionData = (
  tr: (key: string, ...params: string[]) => string
): NewFeatureCarouselModalType => ({
  slides: [
    {
      slug: 'qsg-complete-modal',
      title: tr('perform.onboarding.qsg.complete.title'),
      imageBgColor: Colors.purple[25],
      image: Illustrations.person_with_confetti_falling_with_purple_bg,
      imageWidth: '200px',
      nextBtnLabel: tr('perform.onboarding.qsg.complete.next_button'),
      description: tr('perform.onboarding.qsg.complete.description'),
    },
  ],
});
